/**
 * file : Authentication/Login.jsx
 * 설명 : 로그인
 */

import Logo from "assets/images/logo_pop.png";

import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { client, common } from "../../store/actions";
import { AxiosCall, Fnc, Swal } from "common/globals";
import { Spinner } from "components/Common/Componentization";

export default function Login() {

  document.title = "로그인";

  const dispatch = useDispatch();
  const [userLogin, setUserLogin] = useState([]);
  const change = (key, val) => { setUserLogin({ ...userLogin, [key]: val }) }
  const [dataLoading, setDataLoading] = useState(false);
  
  const queryParams = new URLSearchParams(window.location.search);
  const userid = (queryParams.get('userid') === 'null' || Fnc.Empty(queryParams.get('userid'))) ? userLogin.id : queryParams.get('userid');
  const key = (queryParams.get('key') === 'null' || Fnc.Empty(queryParams.get('key'))) ? null : queryParams.get('key');

  const Login = async () => {
    setDataLoading(true);

    try {
      let response;
      if (Fnc.Empty(key)) {
        response = await AxiosCall.patch(`/login`, { userid: userLogin.id, password: userLogin.pw });
      } else {
        response = await AxiosCall.get(`/login-key?userid=${userid}&key=${key}`);
      }

      const { commons, tokens, tournaments, vendors, note_cnt } = response.data.datas;

      // common 데이터 포맷팅
      const formattedCommons = commons.reduce((acc, curr) => {
        if (!acc[curr.group_code]) acc[curr.group_code] = [];
        acc[curr.group_code].push({
          name: curr.name,
          value: curr.code
        });
        return acc;
      }, {});

      // vendor 데이터 포맷팅
      const formattedVendors = vendors.map((item) => ({ name: item.name, value: item.idx }));

      // tournament 데이터 포맷팅
      const formattedTournaments = {
        all: tournaments.map((item) => ({ name: item.name, value: item.idx })),
        s: tournaments.filter((row) => row.state === 'S').map((item) => ({ name: item.name, value: item.idx })),
        t: tournaments.filter((row) => row.state === 'T').map((item) => ({ name: item.name, value: item.idx }))
      };

      // redux 데이터 삽입
      dispatch(common(formattedCommons, formattedTournaments, formattedVendors));
      dispatch(client(note_cnt, tokens));

      const currentUrl = window.location.href
      const newUrl = currentUrl.includes('?') ? currentUrl.split('?')[0] : currentUrl
      window.location.href = newUrl

    } catch (err) {
      const response = err.response;
      if (response && (response.status === 422 || response.status === 500)) {
        Swal.SwalAlert('error', '오류', `<p>로그인 오류 발생</p><div>${response.data.message}</div>`);
      }
    } finally {
      setDataLoading(false);
    }
  }
  // key값이 존재한다면 로그인 호출
  useEffect(() => {
    !Fnc.Empty(key) && Login()
  }, []);
  return (
    <>
      <Spinner show={dataLoading} />
      <div className="auth">
        <div className="write_box input-type mypage_content box_style1">
          <h2><img src={Logo} alt="tmt" /><span>로그인</span></h2>
          <div className="tit_box">
            <p>아이디</p>
            <input
              type="text"
              placeholder="아이디 입력"
              className="input-type"
              onChange={(e) => {change('id', e.target.value)}}
              onKeyDown={(e) => { Fnc.enterEvent(e, Login) }}
            />
          </div>
          <div className="tit_box">
            <p>비밀번호</p>
            <input
              type="password"
              placeholder="비밀번호 입력"
              className="input-type"
              onChange={(e) => {change('pw', e.target.value)}}
              onKeyDown={(e) => { Fnc.enterEvent(e, Login) }}
            />
          </div>
          <div className="btns">
            <Link to="/Signup" className="btn_basic bg0">회원가입</Link>
            <div />
            <Link className="btn_basic bg2" onClick={Login}>로그인</Link>
          </div>
        </div>
      </div>
    </>
  )
}